import { UserSettings } from '../services/auth/user.service';

export interface CoreState {
  readonly settings: UserSettings | null;
}

export const initialState: CoreState = { settings: null };
